'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Global error:', error);
  }, [error]);

  return (
    <html lang="en">
      <body style={{ backgroundColor: '#0A1E2E', color: '#E8D5B7', fontFamily: 'system-ui, sans-serif', margin: 0, padding: 0 }}>
        <div style={{ maxWidth: '600px', margin: '0 auto', padding: '100px 20px', textAlign: 'center' }}>
          <div style={{ fontSize: '80px', marginBottom: '20px' }}>💥</div>
          <h1 style={{ fontSize: '36px', marginBottom: '20px' }}>Critical Error</h1>
          <p style={{ fontSize: '18px', color: 'rgba(232, 213, 183, 0.7)', marginBottom: '30px' }}>
            We encountered a critical error. Please refresh the page.
          </p>
          <button
            onClick={reset}
            style={{
              backgroundColor: '#E89841',
              color: '#0A1E2E',
              border: 'none',
              padding: '12px 24px',
              fontSize: '16px',
              fontWeight: 'bold',
              borderRadius: '8px',
              cursor: 'pointer',
            }}
          >
            Refresh Page
          </button>
        </div>
      </body>
    </html>
  );
}
